import http from './http'

//  查询所有启用的CMS模块
export function getAllCmsModel() {
  return http({
    url: '/api/cms/openwebsite/findAllCmsModel',
    method: 'get',
    loading: false
  })
}

export function getByNoticeId(noticeId) {
  return http({
    url: `/api/cms/openwebsite/findNoticeByNoticeId/${noticeId}`,
    method: 'get',
    loading: false
  })
}

// 查询所有启用的CMS配置信息
export function getCmsConfig() {
  return http({
    url: `/api/cms/openwebsite/findCmsConfigInfo`,
    method: 'get',
    loading: false
  })
}

// 获取CMS自定义业务类型配置信息
export function getCmsCustomBizTypeConfig() {
  return http({
    url: `/api/cms/openwebsite/getCmsCustomBizTypeConfig`,
    method: 'get',
    loading: false
  })
}

// 查询所有启用的CMS通知
export function getCmsNotice() {
  return http({
    url: `/api/cms/openwebsite/findAllCmsNotice`,
    method: 'get',
    loading: false
  })
}

// 查询所有启用的CMS通知详情
export function getCmsNoticedetails(noticeId) {
  return http({
    url: `/api/cms/openwebsite/findNoticeByNoticeId/${noticeId}`,
    method: 'get',
    loading: false
  })
}

// 根据fileType查询指定类型的通用文件   下载
export function getCommonFile(params) {
  return http({
    url: `/api/cms/openwebsite/pageFindCommonFileByFileType`,
    method: 'get',
    params,
    loading: false
  })
}

// 根据fileType查询指定类型的通用文件   下载
export function getCommonFileByFileId(fileId) {
  return http({
    url: `/api/cms/openwebsite/findCommonFileByFileId/${fileId}`,
    method: 'get',
    loading: false
  })
}

// 根据fileType查询指定类型的通用文件   下载
export function getCommonFiledown(upId) {
  return http({
    responseType: 'blob',
    headers: { 'Content-Type': 'application/json; application/octet-stream' },
    url: `api/cms/openwebsite/downloadFile/${upId}`,
    method: 'get',
    timeout: 30000
  })
}
//
export function getCommonSearch(params) {
  return http({
    url: `/api/cms/openwebsite/findChannelItem`,
    method: 'get',
    params,
    loading: false
  })
}
// 轮播图 banner
export function getbanner() {
  return http({
    url: `/api/cms/openwebsite/findCommonFileByFileType/3`,
    method: 'get',
    loading: false
  })
}
// 广告
export function getAD() {
  return http({
    url: `/api/cms/openwebsite/findCommonFileByFileType/4`,
    method: 'get',
    loading: false
  })
}
// 问题
export function getQuestionByType(questionCategory) {
  return http({
    url: `/api/cms/openwebsite/getQuestionByType/${questionCategory}`,
    method: 'get',
    loading: false
  })
}
// 采集签名二维码
export function getCollectSignQrCode() {
  return http({
    url: `/api/cms/openwebsite/findCommonFileByFileType/116`,
    method: 'get',
    loading: false
  })
}

// export function cmsGetUrl(params) {
//   return http({
//     url: '/apx/sino-system/param/cmsGetUrl',
//     method: 'get',
//     params: {
//       ...params
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/api/home.js